import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.less'
import { Toast } from 'vant';
import { i18n } from '@/locales/i18n'

Vue.use(Toast);
Vue.config.productionTip = false
Vue.prototype.$toast = Toast
/*Vue.use(Element, {
    locale: localStorage.getItem('lang') === 'zh-CN' ? zhLocale : enLocale
})*/
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
